export default "https://kr-a.kakaopagecdn.com/web/qa/5.5.0-rc.0/static/share/icon-sns-tw-6ee3e5aa1d9178829d71b0f727fa439e.svg";